import Container from '~/components/container/Container';
import NoContent from '~/components/noContent/NoConTent';

function AlbumOther() {
    return (
        <Container>
            <NoContent />
        </Container>
    );
}

export default AlbumOther;
